import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin', label: 'Tableau de bord', icon: '📊' },
    { path: '/admin/products', label: 'Produits', icon: '🕯️' },
    { path: '/admin/themes', label: 'Thèmes', icon: '🎨' },
    { path: '/admin/fragrances', label: 'Senteurs', icon: '🌸' },
    { path: '/admin/testimonials', label: 'Avis', icon: '⭐' },
    { path: '/admin/settings', label: 'Paramètres', icon: '⚙️' },
    { path: '/admin/users', label: 'Utilisateurs', icon: '👥' }
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: '250px',
        backgroundColor: '#2c3e50',
        color: 'white',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#9c6f44', marginBottom: '0.5rem' }}>Cire Étoilée</h2>
        </div>

        <nav style={{ flex: 1 }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {menuItems.map(item => (
              <li key={item.path} style={{ marginBottom: '0.5rem' }}>
                <Link
                  to={item.path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0.75rem 1rem',
                    color: location.pathname === item.path ? '#9c6f44' : 'white',
                    backgroundColor: location.pathname === item.path ? 'rgba(156, 111, 68, 0.1)' : 'transparent',
                    textDecoration: 'none',
                    borderRadius: '4px',
                    transition: 'background-color 0.2s'
                  }}
                >
                  <span style={{ marginRight: '0.75rem', fontSize: '1.25rem' }}>{item.icon}</span>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1rem' }}>
          <div style={{ marginBottom: '1rem', fontSize: '0.875rem', color: '#95a5a6' }}>
            Connecté en tant que<br />
            <strong style={{ color: 'white' }}>{user?.username}</strong>
          </div>
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '0.5rem',
              backgroundColor: 'transparent',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Déconnexion
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{
        flex: 1,
        backgroundColor: '#ecf0f1',
        padding: '2rem',
        overflowY: 'auto'
      }}>
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
